import strings from 'owa-strings/owa-options-strings';
function convertDeviceStatusToLocString(status) {
    switch (status) {
        case 'DeviceOk':
            return strings.options_mobile_status_ok;
        case 'DeviceBlocked':
            return strings.options_mobile_status_deviceBlocked;
        case 'DeviceWipePending':
            return strings.options_mobile_status_deviceWipePending;
        case 'DeviceWipeSucceeded':
            return strings.options_mobile_status_deviceWipeSucceeded;
        default:
            return strings.options_mobile_status_ok;
    }
}
function convertDeviceStateReasonToLocString(stateReason) {
    switch (stateReason) {
        case 'Global':
            return strings.options_mobile_stateReason_global;
        case 'Individual':
            return strings.options_mobile_stateReason_individual;
        case 'DeviceRule':
            return strings.options_mobile_stateReason_deviceRule;
        case 'Upgrade':
            return strings.options_mobile_stateReason_upgrade;
        case 'Policy':
            return strings.options_mobile_stateReason_policy;
        case 'ExternalCompliance':
            return strings.options_mobile_stateReason_externalCompliance;
        case 'ExternalEnrollment':
            return strings.options_mobile_stateReason_externalEnrollment;
        case 'ExternallyManaged':
            return strings.options_mobile_stateReason_externallyManaged;
        case 'UnfamiliarLocation':
            return strings.options_mobile_stateReason_unfamiliarLocation;
        default:
            return '';
    }
}
function convertDeviceAccessStateToLocString(accessState) {
    switch (accessState) {
        case 'Allowed':
            return strings.options_mobile_accessState_allowed;
        case 'Blocked':
            return strings.options_mobile_accessState_blocked;
        case 'Quarantined':
            return strings.options_mobile_accessState_quarantined;
        default:
            return '';
    }
}
export function getDevicesFromStatistics(deviceStatistics) {
    return deviceStatistics.map(function (device) {
        return {
            identity: device.Identity,
            deviceName: device.DeviceFriendlyName,
            phoneNumber: device.DevicePhoneNumber,
            firstSyncTime: device.FirstSyncTime,
            lastSyncTime: device.LastSyncAttemptTime,
            lastSuccessSync: device.LastSuccessSync,
            status: convertDeviceStatusToLocString(device.Status),
            folderSynced: device.NumberOfFoldersSynced,
            deviceModel: device.DeviceModel,
            mobileNetwork: device.DeviceMobileOperator,
            deviceType: device.DeviceType,
            deviceID: device.DeviceId,
            deviceIMEI: device.DeviceImei,
            deviceOS: device.DeviceOS,
            deviceLanguage: device.DeviceOSLanguage,
            userAgent: device.DeviceUserAgent,
            accessState: convertDeviceAccessStateToLocString(device.DeviceAccessState),
            accessSetBy: convertDeviceStateReasonToLocString(device.DeviceAccessStateReason),
            clientType: device.ClientType,
            protocolVersion: device.ClientVersion,
        };
    });
}
//# sourceMappingURL=getDevicesFromStatistics.js.map